import * as React from 'react';
import * as Checkbox from '@radix-ui/react-checkbox';
import clsx from 'clsx';

type TagsGroupProps = {
  className?: string;
  selected: string[];
  onTagChange: (label: string, value: boolean | 'indeterminate') => void;
};

const labels = ['Virtual', 'Conference', 'Meetup', 'TransformX'];

export const TagsGroup = ({ className, selected, onTagChange }: TagsGroupProps) => {
  return (
    <div className={clsx('font-unicode flex gap-[9px]', className)} aria-label="category picker">
      {labels.map(label => (
        <Tag
          key={`checkbox-${label}`}
          checked={selected.includes(label)}
          onCheckedChange={val => onTagChange(label, val)}
        >
          {label}
        </Tag>
      ))}
    </div>
  );
};

type TagProps = {
  children: React.ReactNode;
  as?: 'span' | 'checkbox';
  className?: string;
} & Checkbox.CheckboxProps;

export const Tag = ({ children, className, as = 'checkbox', ...props }: TagProps) => {
  const styles = 'w-fit rounded-3xl px-4 font-[600] bg-[#C88BC4] bg-opacity-10 text-[#D1AAD7]';
  if (as === 'span')
    return (
      <span className={clsx(styles, 'h-[34px] flex items-center text-sm', className)}>
        {children}
      </span>
    );

  return (
    <Checkbox.Root className="relative" {...props}>
      <Checkbox.Indicator className="peer sr-only" id={`checkbox-${children.toString()}`} />
      <label
        className={clsx(
          styles,
          'cursor-pointer border border-transparent flex items-center h-12 peer-data-[state=checked]:border-[#D1AAD7]',
          className
        )}
        htmlFor={`checkbox-${children.toString()}`}
      >
        {children}
      </label>
    </Checkbox.Root>
  );
};
